var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{class:['image-card', _vm.fixedHeight && 'fixed-height']},[_c('div',{staticClass:"img",style:({ backgroundImage: `url(${_vm.src})` })}),(_vm.tag)?_c('span',{staticClass:"tag text7"},[_vm._v(_vm._s(_vm.formattedTag))]):_vm._e(),_c('div',{staticClass:"content"},[_vm._t("default")],2)])
}
var staticRenderFns = []

export { render, staticRenderFns }